import { instance } from '../instance';

export const validExprFilter = (param) => instance.post('datarule/validexprfilter', param);

export const validTargetWhereCondition = (param) => instance.post('datarule/validtargetwherecondition', param);
